import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vehicle-insurance',
  templateUrl: './vehicle-insurance.component.html',
  styleUrls: ['./vehicle-insurance.component.scss']
})
export class VehicleInsuranceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
